import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';

import './_ErrorPage.scss';

import logo from '@adsk/bim360-matrix-react-assets/logo.svg';
import maintenanceErrorImage from '@adsk/bim360-matrix-react-assets/maintenance-error-image.svg';

const ErrorPage = ({ renderContent, errorIconProps }) => (
  <div className="ErrorPage">
    <div className="ErrorPage__logo-container">
      <SvgIcon width="250px" height="35px">
        {logo}
      </SvgIcon>
    </div>
    <div className="ErrorPage__error-image-container">
      <SvgIcon
        {...errorIconProps}
        className={cx('ErrorPage__error-image', errorIconProps.className)}
        width="930px"
        height="620px"
      >
        {maintenanceErrorImage}
      </SvgIcon>
    </div>
    {renderContent()}
  </div>
);

ErrorPage.propTypes = {
  /**
   * A function to render the content of the error page.
   */
  renderContent: PropTypes.func.isRequired,
  /**
   * Custom props to add to the error icon
   */
  errorIconProps: PropTypes.object
};

ErrorPage.defaultProps = {
  errorIconProps: {}
};

export default ErrorPage;
